// import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout as AntdLayout } from 'antd';
import { Header } from './header/indexHeader';
import './layout.less';
// import { useValidateLogin } from '@/hooks/hooksIndex';

const { Content } = AntdLayout;

export const SimpleLayout = () => {
  // const [validating, setValidating] = useState(true);
  
  // 验证用户登录状态
  // useValidateLogin({
  //   onValidateComplete: () => setValidating(false)
  // });

  return (
    <AntdLayout style={{ minHeight: '100vh' }}>
      <Header />
      <Content 
        style={{ 
          padding: '0 4px',
          height: `calc(100vh - var(--header-height))`,
          overflowY: 'auto',
          transition: 'all 0.2s'
        }}
      >
        {/* <Spin spinning={validating}> */}
          <Outlet />
        {/* </Spin> */}
      </Content>
    </AntdLayout>
  );
}; 